<ng-template #browserAlertDialog let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ 'ucs.browser-alert.warning' | translate }}</h4>
    <button (click)="d()" aria-label="Close" class="btn-close btn-close-white" type="button">
      <span aria-hidden="true"></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="warning-text">
      <ucs-icon [class]="'feather-black'" [shape]="'feather/alert-triangle'" [size]="20"
                class="pe-1 warning-symbol"></ucs-icon>
      <p>
        <strong>{{ 'ucs.browser-alert.attention' | translate }}</strong>
        {{ 'ucs.browser-alert.browser-not-supported' | translate }}
      </p>
    </div>
    <div class="info-text">
      <p>{{ 'ucs.browser-alert.link-to' | translate }}
        <a href="https://www.google.com/chrome" rel="noopener"
           target="_blank">{{ 'ucs.browser-alert.google-chrome-download' | translate }}</a>
      </p>
      <p>{{ 'ucs.browser-alert.questions' | translate }}</p>
    </div>
  </div>
  <div class="modal-footer">
    <button (click)="c()"
            class="btn btn-primary"
            data-cy="browser-alert-dialog-component.acknowledged-btn"
            type="button">{{ 'ucs.browser-alert.acknowledged' | translate }}
    </button>
  </div>
</ng-template>
